import { render, staticRenderFns } from "./OperationLogList.vue?vue&type=template&id=04a72f28"
import script from "./OperationLogList.vue?vue&type=script&lang=js"
export * from "./OperationLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports